import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { PlayerStreakDto, StreakXpAwardListDto, StreakXpAwardParams } from './streak.schema';
import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { streakApi } from './streak.api';

export const streakQueryOptions = {
  me: (options?: QueryOptionsOverride<PlayerStreakDto>) => queryOptions({
    queryKey: [QueriesKeys.mePlayerStreak],
    queryFn: () => streakApi.getMeStreak(),
    ...options,
  }),

  xpAwards: (params?: StreakXpAwardParams, options?: QueryOptionsOverride<StreakXpAwardListDto>) => queryOptions({
    queryKey: [QueriesKeys.streakXpAwards, params],
    queryFn: () => streakApi.getXpAwards(params),
    staleTime: 1000 * 60 * 30,
    ...options,
  }),

  xpAwardsInfinite: () => infiniteQueryOptions({
    queryKey: [QueriesKeys.streakXpAwards, 'infinite'],
    queryFn: ({ pageParam }) => streakApi.getXpAwards({
      page: pageParam,
      limit: 20,
    }),
    initialPageParam: 1,
    getNextPageParam: page => page.hasNextPage ? page.page + 1 : undefined,
    staleTime: 1000 * 60 * 30,
  }),
};
